(() => {
  const initialize = (info) => {
    const dock = info.querySelector('.nq-mobile-purchase');
    const purchase = info.querySelector('.product-form__submit');
    if (!dock || !purchase || dock.dataset.ready) return;
    dock.dataset.ready = 'true';
    const mobile = matchMedia('(max-width: 749px)');
    let visible = false;
    const sync = () => {
      const footer = document.querySelector('.footer');
      const inFooter = footer && footer.getBoundingClientRect().top < innerHeight;
      dock.hidden = !mobile.matches || visible || inFooter || purchase.getBoundingClientRect().top > 0;
      const price = info.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price-item--regular');
      if (price) dock.querySelector('[data-nq-dock-price]').textContent = price.textContent.trim();
    };
    new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; sync(); }).observe(purchase);
    new MutationObserver(sync).observe(info.querySelector('.noahq-product-price') || info.querySelector('.product__info-container'), { childList: true, subtree: true });
    addEventListener('scroll', sync, { passive: true });
    mobile.addEventListener('change', sync);
    dock.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const target = info.querySelector('variant-selects') || purchase;
      target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      (target.querySelector('input:checked, select') || purchase).focus({ preventScroll: true });
    });
    sync();
  };
  const scan = () => document.querySelectorAll('product-info[data-nq-product-layout]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
